<template>
  <div class="home-box">
    <PageTitle :title="pageTitle" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <PurchaseOrderCreateForm
          :formData="formData"
          :uuid="uuid"
          :proploading="loading"
        ></PurchaseOrderCreateForm>
      </div>
    </v-row>
  </div>
</template>

<script>
import PurchaseOrderCreateForm from "@/components/purchaseorder/PurchaseOrderCreateForm";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "CreatePurchaseOrder",
  components: {
    PageTitle,
    PurchaseOrderCreateForm,
  },
  props: {
    uuid: { type: String, default: null },
  },
  data: function() {
    return {
      role: localStorage.getItem("role") || null,
      errors: null,
      loading: false,
      formData: {
        requisition_id: "",
        supplier_code: "",
        items: [],
        comment: "",
        expected_delivery_date: "",
        status: "pending",
      },
    };
  },
  computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    pageTitle() {
      return "Create Purchase Order";
    },
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },

};
</script>
